var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "heavy-dom-section" },
    [
      _c("section", { staticClass: "pt-0 print-no-vertical" }, [
        _vm.activeSuite &&
        _vm.activeSuite.company &&
        (_vm.showTitle || _vm.user.isAdmin)
          ? _c("p", { staticClass: "title is-4 print-pad-top" }, [
              _vm._v("\n      " + _vm._s(_vm.activeSuite.company.name) + " "),
              _c("br"),
              _vm._v(" "),
              _vm.activeSuite.company &&
              _vm.activeSuite.company.name !== _vm.activeSuite.name
                ? _c("span", { staticClass: "title is-6" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.activeSuite.name) + "\n      "
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isReport
          ? _c("div", { staticClass: "schedule-legend mb-4" }, [
              _c("span", { staticClass: "legend-label is-semibold" }, [
                _vm._v("\n        LEGEND\n      ")
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._l(_vm.sortedActiveScheduleKeys, function(meetingDate) {
        return _c(
          "section",
          { key: meetingDate, staticClass: "my-8 print-no-vertical" },
          [
            _c(
              "div",
              { staticClass: "flex justify-items-start items-center mb-6" },
              [
                _vm.activeSuite.logo_path
                  ? _c("img", {
                      staticClass:
                        "object-contain block mr-4 w-10 lg:w-16 h-10 lg:h-16 m-0",
                      staticStyle: { "border-radius": "3px" },
                      attrs: {
                        src: _vm.fixHttpProtocol(_vm.activeSuite.logo_path)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass:
                      "media-content lg:text-lg subtitle is-5 is-bold"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDate(meetingDate)) +
                        "\n      "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "box print-no-vertical" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table is-hoverable is-fullwidth table-with-data-labels"
                },
                [
                  _vm._m(1, true),
                  _vm._v(" "),
                  _vm._l(_vm.activeSchedule[meetingDate], function(
                    timeslot,
                    tsIndex
                  ) {
                    return _c(
                      "tr",
                      {
                        key: tsIndex,
                        class: {
                          blocked:
                            !timeslot.is_open && timeslot.scheduled_with === ""
                        },
                        style: {}
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "align-middle",
                            staticStyle: { width: "30%" },
                            attrs: { "data-label": "Time" }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  timeslot.start_time +
                                    " - " +
                                    timeslot.end_time +
                                    " " +
                                    _vm.displayedTimezone
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "align-middle",
                            attrs: { "data-label": "" }
                          },
                          [
                            _vm.isReport &&
                            !timeslot.is_open &&
                            timeslot.scheduled_with === ""
                              ? _c("div", { staticClass: "show-blocked" }, [
                                  _vm._v(
                                    "\n              BLOCKED\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            timeslot.scheduled_with !== ""
                              ? _c(
                                  "div",
                                  { staticClass: "appointment-actions" },
                                  [
                                    _c("appointment-actions", {
                                      staticClass: "mb-2 p-0 lg:mb-0",
                                      attrs: {
                                        "is-suite-writeable":
                                          _vm.isSuiteWriteable,
                                        "meeting-id": _vm.id,
                                        "suite-id": timeslot.scheduled_with,
                                        timeslot: timeslot,
                                        type: "scheduled"
                                      },
                                      on: {
                                        cancel: function($event) {
                                          return _vm.showCancelOrReschedule(
                                            timeslot,
                                            timeslot.scheduled_with,
                                            meetingDate,
                                            "scheduled"
                                          )
                                        },
                                        addToCalendar: function($event) {
                                          return _vm.addToCalendar(
                                            $event,
                                            meetingDate,
                                            timeslot
                                          )
                                        },
                                        addGuest: _vm.addGuest
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.user.isAdmin &&
                                    timeslot.guests &&
                                    timeslot.guests.length
                                      ? [
                                          _c(
                                            "b",
                                            { staticClass: "block mb-0 mt-1" },
                                            [_vm._v("Guests:")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(timeslot.guests, function(
                                            guest,
                                            guestIndex
                                          ) {
                                            return _c(
                                              "p",
                                              { key: guestIndex },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(guest.name) +
                                                    "\n                  "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.deleteGuest(
                                                          timeslot,
                                                          guest.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("(remove)")]
                                                )
                                              ]
                                            )
                                          })
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isReport
                              ? _c(
                                  "div",
                                  { staticClass: "lg:flex flex-wrap" },
                                  _vm._l(timeslot.pending, function(
                                    pending,
                                    pendingIdx
                                  ) {
                                    return _c("appointment-actions", {
                                      key: pendingIdx,
                                      staticClass:
                                        "my-2 p-0 first:ml-0 ml-0 lg:ml-2",
                                      attrs: {
                                        "is-suite-writeable":
                                          _vm.isSuiteWriteable,
                                        "meeting-id": _vm.id,
                                        "suite-id": pending.suiteId,
                                        timeslot: timeslot,
                                        type: pending.type
                                      },
                                      on: {
                                        approve: function($event) {
                                          return _vm.scheduleMeeting(
                                            timeslot,
                                            pending.suiteId,
                                            _vm.meetingSuites[pending.suiteId]
                                              .name
                                          )
                                        },
                                        cancel: function($event) {
                                          return _vm.showCancelOrReschedule(
                                            timeslot,
                                            pending.suiteId,
                                            meetingDate,
                                            "pending"
                                          )
                                        }
                                      }
                                    })
                                  }),
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "has-text-right is-hidden-print align-middle",
                            attrs: { "data-label": "" }
                          },
                          [
                            !timeslot.is_open && timeslot.scheduled_with === ""
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-small is-outlined",
                                      attrs: {
                                        type: "button",
                                        disabled: !_vm.canChangeBlock
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setUnblock(timeslot)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "svg-inline--fa fa-lock fa-w-14 mr-2",
                                          attrs: {
                                            "aria-hidden": "true",
                                            role: "img"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#icon-unlock"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                Unblock\n              "
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-small is-outlined",
                                      attrs: {
                                        title: _vm.getMouseoverText(timeslot),
                                        disabled:
                                          timeslot.scheduled_with !== "" ||
                                          timeslot.pending.length > 0 ||
                                          !_vm.canChangeBlock,
                                        type: "button"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setBlock(timeslot)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "svg-inline--fa fa-lock fa-w-14 mr-2",
                                          attrs: {
                                            "aria-hidden": "true",
                                            role: "img"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#icon-lock"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                Block\n              "
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "print-page-break" }),
      _vm._v(" "),
      _vm.showRescheduleModal
        ? _c(
            "modal",
            {
              attrs: { title: "Cancel/Reschedule", "show-close-button": false }
            },
            [
              _c("h5", { staticClass: "title is-5" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.meetingSuites[_vm.rescheduleData.suiteId]
                        ? _vm.getCompanySuiteName(
                            _vm.meetingSuites[_vm.rescheduleData.suiteId].name,
                            _vm.meetingSuites[_vm.rescheduleData.suiteId]
                              .company.name
                          )
                        : ""
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c("h6", { staticClass: "subtitle is-6" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatDate(_vm.rescheduleData.meetingDate)) +
                    "\n      " +
                    _vm._s(_vm.rescheduleData.timeslot.start_time) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("What would you like to do?")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("label", { staticClass: "radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rescheduleData.cancelOrReschedule,
                          expression: "rescheduleData.cancelOrReschedule"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "cancelOrReschedule",
                        value: "cancel"
                      },
                      domProps: {
                        checked: _vm._q(
                          _vm.rescheduleData.cancelOrReschedule,
                          "cancel"
                        )
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(
                            _vm.rescheduleData,
                            "cancelOrReschedule",
                            "cancel"
                          )
                        }
                      }
                    }),
                    _vm._v("\n          Cancel\n        ")
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rescheduleData.cancelOrReschedule,
                          expression: "rescheduleData.cancelOrReschedule"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "cancelOrReschedule",
                        value: "reschedule"
                      },
                      domProps: {
                        checked: _vm._q(
                          _vm.rescheduleData.cancelOrReschedule,
                          "reschedule"
                        )
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(
                            _vm.rescheduleData,
                            "cancelOrReschedule",
                            "reschedule"
                          )
                        }
                      }
                    }),
                    _vm._v(
                      "\n          Cancel and request a new time\n        "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.rescheduleData.cancelOrReschedule === "reschedule"
                ? _c(
                    "div",
                    _vm._l(_vm.sortedActiveScheduleKeys, function(meetingDate) {
                      return _c("reschedule-slots", {
                        key: meetingDate,
                        attrs: {
                          "reschedule-data": _vm.rescheduleData,
                          "user-schedule": _vm.activeSchedule,
                          slots: _vm.rescheduleData.suiteSchedule[meetingDate],
                          "meeting-date": _vm.formatDate(meetingDate)
                        }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "field mt-4" }, [
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rescheduleData.notes,
                        expression: "rescheduleData.notes"
                      }
                    ],
                    staticClass: "textarea",
                    attrs: { placeholder: "Include an optional note" },
                    domProps: { value: _vm.rescheduleData.notes },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.rescheduleData,
                          "notes",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-danger",
                    class: { "is-loading": _vm.rescheduleData.isLoading },
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.rescheduleData.isLoading ||
                        (_vm.rescheduleData.cancelOrReschedule !== "cancel" &&
                          _vm.rescheduleData.cancelOrReschedule !==
                            "reschedule")
                    },
                    on: { click: _vm.cancelOrReschedule }
                  },
                  [_vm._v("\n        Cancel/Reschedule\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: {
                      type: "button",
                      disabled: _vm.rescheduleData.isLoading
                    },
                    on: {
                      click: function($event) {
                        _vm.showRescheduleModal = false
                      }
                    }
                  },
                  [_vm._v("\n        Nevermind\n      ")]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "level" }, [
      _c("p", { staticClass: "level-item has-text-centered" }, [
        _c(
          "button",
          { staticClass: "button is-small is-text", attrs: { disabled: "" } },
          [
            _c("span", { staticClass: "icon is-small" }, [
              _c("i", {
                staticClass: "far fa-calendar-check",
                attrs: { "aria-hidden": "true" }
              })
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Appointment is scheduled")])
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "level-item has-text-centered" }, [
        _c(
          "button",
          { staticClass: "button is-small is-text", attrs: { disabled: "" } },
          [
            _c("span", { staticClass: "icon is-small" }, [
              _c("i", {
                staticClass: "fas fa-reply",
                attrs: { "aria-hidden": "true" }
              })
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Awaiting your response")])
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "level-item has-text-centered" }, [
        _c(
          "button",
          { staticClass: "button is-small is-text", attrs: { disabled: "" } },
          [
            _c("span", { staticClass: "icon is-small" }, [
              _c("i", {
                staticClass: "far fa-hourglass",
                attrs: { "aria-hidden": "true" }
              })
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Request waiting for approval")])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "is-hidden-print" }, [
      _c("th", { attrs: { scope: "col", colspan: "3" } }, [_vm._v("Time Slot")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44c446c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44c446c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attendees/Schedule.vue
// module id = null
// module chunks = 